import { OrganizationRequest } from '../request-models/organization-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * The body for `POST /organizations`: the hub's `CreateOrganizationRequest` fields that are set. Org hierarchy
 * (`parentOrganizationId`, `billingResponsibility`) is admin-only, so the hub ignores both on create.
 */
export function toOrganizationCreateRequest(fields: OrganizationRequest): OrganizationRequest {
  return omitUndefined<OrganizationRequest>(addressAndContact(fields));
}

/**
 * The body for `PUT /organizations/:id`: only the hub's `ORGANIZATION_WRITABLE` fields that are set, so an
 * update stays partial. `null` (clear the field) is kept.
 */
export function toOrganizationUpdateRequest(fields: OrganizationRequest): OrganizationRequest {
  return omitUndefined<OrganizationRequest>({
    ...addressAndContact(fields),
    serviceRadiusMiles: fields.serviceRadiusMiles,
  });
}

/** The fields both create and update accept, copied by name. */
function addressAndContact(fields: OrganizationRequest): OrganizationRequest {
  return {
    name: fields.name,
    organizationType: fields.organizationType,
    ein: fields.ein,
    ssn: fields.ssn,
    streetAddressLine1: fields.streetAddressLine1,
    streetAddressLine2: fields.streetAddressLine2,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
    country: fields.country,
    email: fields.email,
    phone: fields.phone,
  };
}
